/**
 * Formats a date string or Date object into a human-readable string.
 * Example: "2025-07-28T12:34:56Z" or new Date() => "Jul 28, 2025, 12:34 PM"
 *
 * @param date - The date to format (string, number, or Date)
 * @param options - Intl.DateTimeFormat options (optional)
 * @returns A formatted date string.
 */
export default function formatDate(
    date: string | number | Date,
    options?: Intl.DateTimeFormatOptions
): string {
    if (!date) return "";
    const d = typeof date === "string" || typeof date === "number" ? new Date(date) : date;
    if (isNaN(d.getTime())) return "";
    return d.toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        ...options,
    });
}